import { gql } from '@apollo/client';

export const PATCH_LAST_RECURRING_PAYMENT = gql`
  mutation patchLastRecurringPayment(
    $input: PatchSalesOrderRecurringPaymentStatusInput!
  ) {
    patchLastRecurringPayment(input: $input) {
      chargeUid
      eventType
      id
      nextExecutionTime
      numberOfRetries
      orderLineId
      salesOrderUid
      uid
      charge {
        uid
        chargeType
        vatPercentage
        unitPriceWithoutVat
        unitVatAmount
        version
      }
      created
      updated
    }
  }
`;
